<template>
  <div class="business-person">
    <common-layout>
      <div slot="header">
        <h3>科技评估师专家库</h3>
      </div>
      <div slot="container">
        <div class="business-person.header">
          <el-button class="business-person.addBtn" @click="$router.go(-1)">返回上一页</el-button>
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            style="background: #623AA2; border: none;"
          >
            新增
          </el-button>
          <section>
            <el-input
              style="margin-right:10px;"
              placeholder="请输入专家姓名"
              v-model="paramsObj.consultantName"
              class="input-with-select"
              clearable
              @change="search"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
            <label style="margin-right: 10px; line-height: 40px; min-width: 60px">发布平台:</label>
            <el-select
              style="width: 300px"
              v-model="srelease"
              clearable
              placeholder="请选择发布平台"
              @change="resourceChange"
            >
              <el-option label="双平台" :value="1" />
              <el-option label="大市场平台" :value="2" />
              <el-option label="成果交易平台" :value="3" />
            </el-select>
            <!-- <el-button type="warning" class="active-detail.addBtn" @click="importExcel">导入</el-button> -->
          </section>
        </div>
        <div class="active-detail.table">
          <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
            <el-table-column type="index" label="序号" align="center" width="90">
              <template slot-scope="scope">
                <span>{{ scope.$index + (paramsObj.page - 1) * paramsObj.pageSize + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="consultantName" label="姓名" align="center"></el-table-column>
            <el-table-column prop="certificateNo" label="证书编号" align="center"></el-table-column>
            <el-table-column
              prop="certificateLevel"
              label="证书级别"
              align="center"
            ></el-table-column>
            <el-table-column prop="city" label="地区" align="center"></el-table-column>
            <el-table-column label="发布平台" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.isAchievement === 1 && scope.row.isMarket === 1
                    ? '双平台'
                    : scope.row.isMarket === 1
                    ? '大市场平台'
                    : '成果交易平台'
                }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <div class="grid-content bg-purple-light">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next,jumper"
              :total="total"
              :current-page.sync="paramsObj.page"
              :page-size="paramsObj.pageSize"
            ></el-pagination>
          </div>
        </div>
      </div>
    </common-layout>
    <el-dialog
      title="科技评估师专家库"
      :visible.sync="dialogVis"
      width="30%"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form :model="form" :rules="rules" label-width="80px" ref="form">
        <el-form-item label="姓名" prop="consultantName">
          <el-input
            v-model="form.consultantName"
            autocomplete="off"
            placeholder="请填写姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="证书编号" prop="certificateNo">
          <el-input
            v-model="form.certificateNo"
            autocomplete="off"
            placeholder="请填写证书编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="证书级别" prop="certificateLevel">
          <el-select v-model="form.certificateLevel" style="width:100%">
            <el-option label="初级" value="初级"></el-option>
            <el-option label="中级" value="中级"></el-option>
            <el-option label="高级" value="高级"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证书图片" prop="certificateFileSrc">
          <el-upload
            class="create-modal__avatar"
            :action="this.uploadURL"
            :show-file-list="false"
            list-type="picture"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="form.certificateFileSrc"
              :src="this.imgUrl + form.certificateFileSrc"
              class="create-modal__image"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="地区" prop="area">
          <v-distpicker
            style="text-align: left"
            @selected="citySelected"
            :province="form.area"
            hide-area
            :city="form.city"
          ></v-distpicker>
        </el-form-item>
        <el-form-item label="同步发布" prop="isMarket" style="text-align: left">
          <el-select
            v-model="isMarket"
            placeholder="请选择"
            style="width: 100%"
            @change="formmarket"
          >
            <el-option label="双平台" :value="1" />
            <el-option label="大市场平台" :value="2" />
            <el-option label="成果交易平台" :value="3" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVis = false">取 消</el-button>
        <el-button type="primary" @click="createPerson">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from '../../components/common-layout.vue';
export default {
  components: {
    CommonLayout
  },
  data() {
    return {
      listUrl: `${urlConfig.devUrl}apij2/admin-api/trade/talent-technology/page`,
      is_submit: true,
      srelease: '',
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      guaranteeTypeList: [],
      total: 20,
      tableData: [],
      dialogVis: false,
      operate: 'add',
      isMarket: 1,
      paramsObj: {
        page: 1,
        pageSize: 10,
        consultantName: ''
      },
      form: {
        consultantName: '',
        certificateNo: '',
        certificateLevel: '',
        certificateFileSrc: '',
        area: '甘肃省',
        city: '兰州市',
        isMarket: 1,
        isAchievement: 1
      },
      rules: {
        consultantName: [
          {
            required: true,
            message: '请填写姓名',
            trigger: 'blur'
          }
        ],
        certificateNo: [
          {
            required: true,
            message: '请填写证书编号',
            trigger: 'blur'
          }
        ],
        certificateLevel: [
          {
            required: true,
            message: '请选择证书级别',
            trigger: 'change'
          }
        ],
        certificateFileSrc: [
          {
            required: true,
            message: '请选择证书照片',
            trigger: 'change'
          }
        ],
        area: [
          {
            required: true,
            message: '请选择所属区域',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.form.certificateFileSrc = res.data.store_result;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 10MB!');
      }
      return isLt2M;
    },
    add() {
      this.dialogVis = true;
      this.operate = 'add';
      this.form.id = '';
      this.form.consultantName = '';
      this.form.certificateNo = '';
      this.form.certificateLevel = '';
      this.form.certificateFileSrc = '';
      this.form.area = '甘肃省';
      this.form.city = '兰州市';
      this.form.isMarket = 1;
      this.form.isAchievement = 1;
      this.isMarket = 1;
    },
    handleEdit(row) {
      this.operate = 'edit';
      this.dialogVis = true;
      this.form.id = row.id;
      this.form.consultantName = row.consultantName;
      this.form.certificateNo = row.certificateNo;
      this.form.certificateLevel = row.certificateLevel;
      this.form.certificateFileSrc = row.certificateFileSrc;
      this.form.area = row.area;
      this.form.city = row.city;
      this.form.isMarket = row.isMarket;
      this.isMarket =
        row.isAchievement === 1 && row.isMarket === 1
          ? 1
          : row.isMarket === 1 && row.isAchievement === 2
          ? 2
          : 3;
      console.log('this.isMarket', this.isMarket);
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          // let obj = {
          //   id: row.id
          // };
          this.http
            .delete(`${urlConfig.devUrl}apij2/admin-api/trade/talent-technology/delete?id=${row.id}`)
            .then(res => {
              if (res.code == 0) {
                this.paramsObj.page = 1;
                this.getData();
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
              } else {
                this.$message({
                  message: '失败！',
                  type: 'error'
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    formmarket(val) {
      if (val === 1) {
        this.form.isMarket = 1;
        this.form.isAchievement = 1;
      } else if (val === 2) {
        this.form.isMarket = 1;
        this.form.isAchievement = 2;
      } else {
        this.form.isMarket = 2;
        this.form.isAchievement = 1;
      }
    },
    //城市选择
    citySelected(e) {
      this.form.address = e;
      this.form.area = e.province.value;
      this.form.city = e.city.value;
    },
    search() {
      this.getData();
    },
    resourceChange() {
      console.log('this.srelease', this.srelease);
      if (!this.srelease) {
        delete this.paramsObj.isMarket;
        delete this.paramsObj.isAchievement;
      } else {
        if (this.srelease === 1) {
          this.paramsObj.isMarket = 1;
          this.paramsObj.isAchievement = 1;
        } else if (this.srelease === 2) {
          this.paramsObj.isMarket = 1;
          this.paramsObj.isAchievement = 2;
        } else {
          this.paramsObj.isMarket = 2;
          this.paramsObj.isAchievement = 1;
        }
      }
      this.search();
    },
    getData() {
      this.http.post(this.listUrl, this.paramsObj).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        } else {
          this.$message.error('获取数据失败！！');
        }
      });
    },
    handleCurrentChange(val) {
      this.paramsObj.page = val;
      this.getData();
    },
    createPerson() {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs['form'].validate(valid => {
        if (valid) {
          let obj = {
            consultantName: this.form.consultantName,
            certificateNo: this.form.certificateNo,
            certificateLevel: this.form.certificateLevel,
            certificateFileSrc: this.form.certificateFileSrc,
            area: this.form.area,
            city: this.form.city,
            isMarket: this.form.isMarket,
            isAchievement: this.form.isAchievement
          };
          if (this.operate == 'add') {
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/talent-technology/create`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.$message.success('新增成功');
                  this.isMarket = 1;
                  this.dialogVis = false;
                  this.getData();
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          } else {
            obj.id = this.form.id;
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/talent-technology/update`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.$message.success('编辑成功');
                  this.isMarket = 1;
                  this.dialogVis = false;
                  this.getData();
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;
        }
      });
    }
  },
  mounted() {
    this.getData();
    // this.getGroup()
  }
};
</script>

<style lang="scss">
@include component(business-person) {
  width: 100%;
  height: 100%;
  @include part(header) {
    display: flex;
    justify-content: flex-start;
    @include component(el-input) {
      width: 300px;
    }
    section {
      margin-left: 50px;
    }
  }
  @include part(searchBtn) {
    margin-left: 10px;
    margin-right: 30px;
  }
  @include part(addBtn) {
    margin-left: 30px;
  }
  @include part(table) {
    margin-top: 30px;
  }
  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 178px !important;
    line-height: 178px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .create-modal__avatar {
    border: 1px dashed #d9d9d9;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 178px;
    height: 178px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 178px;
    height: 178px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .create-modal__image {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
